module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_05_stay-52f4672428ddaf9fb18bef09acf17ff6.jpg";